import request from "../shared/http";

class MetaTestService {
  /**
   * Returns connected Meta ad accounts with decrypted tokens for auto-populate.
   * Each item: { id, displayName, adAccountId, accessToken, status }
   */
  static async listMetaAccounts() {
    const { data } = await request.get("/meta-test/meta-accounts");
    return data;
  }

  /**
   * Fire a single Graph API call via the analytics-server proxy.
   * callType rotates through: me_accounts → campaigns → adsets → insights
   * Returns { ok, statusCode, graphError, counters }
   */
  static async runCall(accessToken, adAccountId, callType = "me_accounts") {
    const { data } = await request.post("/meta-test/run", {
      accessToken,
      adAccountId,
      callType,
    });
    return data;
  }

  /**
   * Rotate through user-level call types only — avoids per-ad-account rate limits.
   * me_accounts is weighted 2x since it's the primary Marketing API call.
   */
  static getCallType(index) {
    const types = ["me_accounts", "me", "me_accounts", "me_pages", "me_accounts", "me_businesses"];
    return types[index % types.length];
  }

  /** Reset counters on the server for the current account. */
  static async reset() {
    const { data } = await request.post("/meta-test/reset");
    return data;
  }

  /** Fetch the latest counters from the server. */
  static async getProgress() {
    const { data } = await request.get("/meta-test/progress");
    return data;
  }
}

export default MetaTestService;
